export default function getQuestionChoices(question) {
	const byLetter = {};
	const byIdentity = {};

	if (!question?.choices) return byLetter;

	for (const choice of question.choices) {
		if (choice?.letter != null) byLetter[String(choice.letter)] = choice;
		if (choice?.identity != null)
			byIdentity[String(choice.identity)] = choice;
	}

	// Non-enumerable so loops like for..in/Object.keys won’t see it
	Object.defineProperty(byLetter, '__byIdentity', {
		value: byIdentity,
		enumerable: false,
	});

	return byLetter;
}
